import { jsx as _jsx } from "react/jsx-runtime";
var Award = function Award(_ref) {
  var className = _ref.className,
    _ref$color = _ref.color,
    color = _ref$color === void 0 ? '#181B32' : _ref$color,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 32 : _ref$size,
    ignoreColor = _ref.ignoreColor;
  return /*#__PURE__*/_jsx("svg", {
    className: className,
    width: size,
    height: size,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: /*#__PURE__*/_jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M16.4075 22.2758C15.9928 22.0478 15.4915 22.0518 15.0875 22.2932L10.0901 25.2265L12.0475 17.6132C13.2141 18.2798 14.5621 18.6665 15.9995 18.6665C17.4368 18.6665 18.7848 18.2798 19.9528 17.6132L21.9381 25.3358L16.4075 22.2758ZM15.9995 5.33317C18.9408 5.33317 21.3328 7.72517 21.3328 10.6665C21.3328 13.6078 18.9408 15.9998 15.9995 15.9998C13.0581 15.9998 10.6661 13.6078 10.6661 10.6665C10.6661 7.72517 13.0581 5.33317 15.9995 5.33317ZM25.2915 27.6678L22.2128 15.6958C23.3275 14.3198 23.9995 12.5718 23.9995 10.6665C23.9995 6.2545 20.4115 2.6665 15.9995 2.6665C11.5888 2.6665 7.99946 6.2545 7.99946 10.6665C7.99946 12.5718 8.67146 14.3198 9.78612 15.6958L6.70879 27.6678C6.57412 28.1905 6.76746 28.7412 7.19812 29.0652C7.62746 29.3892 8.21146 29.4185 8.67412 29.1492L15.7808 24.9772L23.3541 29.1665C23.5555 29.2785 23.7781 29.3332 23.9995 29.3332C24.2888 29.3332 24.5768 29.2398 24.8168 29.0545C25.2368 28.7292 25.4248 28.1838 25.2915 27.6678Z",
      fill: !ignoreColor ? color : undefined
    })
  });
};
export default Award;